export default {
      id: "thumbs-up-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#thumbs-up-usage",
      toString: function () {
        return this.url;
      }
    }